import React from 'react';

import { Flex, Box, useColorModeValue, Text, Button, HStack } from '@chakra-ui/react';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from "components/Card/CardBody";
import CustomerKits from 'components/Customer/CustomerKits/CustomerKits';
import CustomerAssestment from 'components/Customer/CustomerAssestment/CustomerAssestment';
import CustomerKitRisks from 'components/Customer/CustomerKitRisks/CustomerKitRisks';
import CustomerKitResult from 'components/Customer/CustomerKitResult/CustomerKitResult';
import LitioValues from './LitioValues';
import { GET_FILE } from 'services/clients';

const CheckUps = ({kits, getDate}) => {
    const [openAssestment, setOpenAssestment] = React.useState(false);
    const [assestment, setAssestment] = React.useState({});
    const [kit, setKit] = React.useState(null);

    const handleKitClick = (kit) => {
        setKit(kit);
        setOpenAssestment(true);
        let kitAssestment = {
            kitTypeId: kit.kit_type_id,
            answers: kit.steps_answers,
            metric: kit.metric,
            result: kit?.exam?.result
        }
        setAssestment(kitAssestment);
    }

    const handleKitClickClose = () => {
        setOpenAssestment(false);
    }

    const downloadFile = async () =>{
        const { link } = await GET_FILE(kit.id);
        window.open(link, '_blank').focus();
    }

    const textColor = useColorModeValue("gray.700", "white");

    if(!openAssestment) {
        return (
            <Card px="0px" pb="0px" minHeight="100px" overflowY={{sm: "auto", lg: "unset"}}>
                <CardHeader px="22px" mb="22px">
                    <Flex
                        justifyContent="center"
                        alignItems="center"
                    >
                    <Text
                      color={textColor}
                      fontSize="lg"
                      fontWeight="bold"
                      mb="3px"
                    >
                        Exames
                    </Text>
                    </Flex>
                </CardHeader>
                <CardBody h="100%" width="100%">
                    <Box w="100%" px="32px" pb="22px">
                        <CustomerKits
                            kits={kits}
                            handleKitClick={handleKitClick}
                            getDate={getDate}
                        />
                    </Box>
                </CardBody>
            </Card>
        )
    } else {
        return (
            <Card px="0px" pb="0px" minHeight="100px" maxH="572px" overflowY={{sm: "auto", lg: "auto"}}>
                <CardHeader px="22px" mb="22px">
                    <Flex
                        width="100%"
                        justifyContent="flex-end"
                        alignItems="center"
                    >
                        <HStack
                            spacing={4}
                        >
                            <Button
                            color={textColor}
                            fontSize="lg"
                            fontWeight="bold"
                            mb="3px"
                            onClick={() => downloadFile()}
                            >
                                Baixar Exame
                            </Button>
                            <Button
                            color={textColor}
                            fontSize="lg"
                            fontWeight="bold"
                            mb="3px"
                            onClick={() => handleKitClickClose()}
                            >
                                Voltar
                            </Button>
                        </HStack>
                    </Flex>
                </CardHeader>
                <CardBody h="100%" width="100%">
                    <Box w="100%" px="32px" pb="22px">
                        {/* <CustomerKitRisks risks={assestment.metric} /> */}
                        <CustomerAssestment answers={assestment.answers} />
                        <CustomerKitResult results={assestment.result} kitTypeId={assestment.kitTypeId} />
                        <LitioValues />
                    </Box>
                </CardBody>
            </Card>
        )
    }

    
}

export default CheckUps